import { render } from "./IconCreditCard.vue.js?vue&type=template&id=449042f6!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconCreditCard.vue?vue&type=template&id=449042f6"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__